
//=================== Produccion  ====================

export const appGlobal = {
    host: process.env.REACT_APP_BASE_URL,
    hostFile: process.env.REACT_APP_BASE_URL,
    urlShare: process.env.REACT_APP_BASE_URL_SHARE,
    errorRequestServer: 'No se generó la petición, verificar conexión al servidor',
    codeErrorRequestServer: 102,
    apiIncode: process.env.REACT_APP_API_INCODE,
    tokenApi: process.env.REACT_APP_API_TOKEN,
    configurationId: process.env.REACT_APP_CONFIGURATION,
    configurationIdLic: process.env.REACT_APP_CONFIGURATION_LIC,
    ev: 'reportes'
}